import { createContext, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { AUTH_CLIENTS, ROLE_PERMISSIONS_MAP } from '../constants';
import { getUser } from '../utils/API/user';

const initialState = {
  language: 'it',
  first_name: '',
  last_name: '',
  email: '',
  sessionId: '',
};

const getRoles = (resourceAccess) => {
  if (!resourceAccess || typeof resourceAccess !== 'object') return [];
  const backendRoles = resourceAccess[AUTH_CLIENTS.i3portalBackend]?.roles;
  if (Array.isArray(backendRoles)) return backendRoles;
  const found = Object.values(resourceAccess).find(
    (v) => v && Array.isArray(v.roles)
  );
  return found ? found.roles : [];
};

const getPermissions = (roles) => {
  const result = new Set();
  roles.forEach((role) => {
    (ROLE_PERMISSIONS_MAP[role] || []).forEach((p) => result.add(p));
  });
  return Array.from(result);
};

export const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState(initialState);
  const [permissions, setPermissions] = useState([]);
  const updateUser = useCallback(
    (data) => setUser((old) => ({ ...old, ...data })),
    []
  );
  const login = useCallback(
    (u, p) => {
      setUser(u);
      setPermissions(getPermissions(getRoles(p)));
      getUser()
        .then(updateUser)
        .catch(() => {});
    },
    [updateUser]
  );
  const logout = useCallback(() => {
    setUser(initialState);
    setPermissions([]);
  }, []);

  const hasClaim = useCallback(
    (claim) => permissions.includes(claim),
    [permissions]
  );
  const value = {
    user: Object.freeze(user),
    login,
    logout,
    updateUser,
    hasClaim,
  };
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

UserContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const UserContext = createContext(initialState);
